// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

import HomePage from "./pages/HomePage";
import CartPage from "./pages/CartPage";
import WishlistPage from "./pages/WishlistPage";
import CheckoutPage from "./pages/CheckoutPage";
import ThankYouPage from "./pages/ThankYouPage";
import AccountPage from "./pages/AccountPage";
import OrdersPage from "./pages/OrdersPage";
import CreateAccountPage from "./pages/CreateAccountPage";
import EditProfilePage from "./pages/EditProfilePage";
import ProductsPage from "./pages/ProductsPage";
import ProductDetailsPage from "./pages/ProductDetailsPage";
import AllProductsPage from "./pages/AllProductsPage";
import RequireAuth from "./components/RequireAuth";
import ContactPage from "./pages/ContactPage";
import ChatPage from "./pages/ChatPage";
import CustomerReviewsPage from "./pages/CustomerReviewsPage";
import LegalPage from "./pages/LegalPage";
import AdminLayout from "./admin/AdminLayout";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import ProtectedAdminRoute from "./admin/ProtectedAdminRoute";
import AdminAddOrders from "./admin/pages/AdminAddOrders";
import AdminReviews from "./admin/pages/AdminReviews";
import AdminProducts from "./admin/pages/AdminProducts";
import AdminAddProduct from "./admin/pages/AdminAddProduct";
import AdminEditProduct from "./admin/pages/AdminEditProduct";
import AdminOrders from "./admin/pages/AdminOrders";
import AdminOrderDetails from "./admin/pages/AdminOrderDetails";
import AdminUsers from "./admin/pages/AdminUsers";
import AdminCustomers from "./admin/pages/AdminCustomers";
import AdminCustomerProfile from "./admin/pages/AdminCustomerProfile";
import AdminAnalytics from "./admin/pages/AdminAnalytics";
import AdminSettings from "./admin/pages/AdminSettings";
import AdminNotifications from "./admin/pages/AdminNotifications";
import AdminInventory from "./admin/pages/AdminInventory";
import AdminMessages from "./admin/pages/AdminMessages";
import AdminMessageView from "./admin/pages/AdminMessageView";
import AdminEmailTemplates from "./admin/pages/AdminEmailTemplates";
import AdminEmailEditor from "./admin/pages/AdminEmailEditor";
import AdminSeoManager from "./admin/pages/AdminSeoManager";
import AdminTopBanner from "./admin/pages/AdminTopBanner";
import AdminCategories from "./admin/pages/AdminCategories";
import AdminSaleBanner from "./admin/pages/AdminSaleBanner";
import AdminShippingSettings from "./admin/pages/AdminShippingSettings";
import AdminNewInProducts from "./admin/pages/AdminNewInProducts";
import AdminBestsellerProducts from "./admin/pages/AdminBestsellerProducts";
import AdminSaleProducts from "./admin/pages/AdminSaleProducts";
import AdminAbandonedCarts  from "./admin/pages/AdminAbandonedCarts";
import AdminUserActivity from "./admin/pages/AdminUserActivity";
import AdminEmailTemplateManager from "./admin/pages/AdminEmailTemplateManager";
import AdminMakeSale from "./admin/pages/AdminMakeSale";
import AdminRemoveSale from "./admin/pages/AdminRemoveSale";

function App() {
  return (
    <Router>
     <Routes>
        {/* ================== CLIENT ================== */}
        <Route path="/" element={<HomePage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/wishlist" element={<WishlistPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/chat" element={<ChatPage />} />
<Route
  path="/privacy-policy"
  element={<LegalPage type="privacy" />}
/>

<Route
  path="/terms-of-service"
  element={<LegalPage type="terms" />}
/>
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />

        <Route
          path="/account"
          element={
            <RequireAuth>
              <AccountPage />
            </RequireAuth>
          }
        />

        <Route
          path="/orders"
          element={
            <RequireAuth>
              <OrdersPage />
            </RequireAuth>
          }
        />

        <Route path="/create-account" element={<CreateAccountPage />} />
        <Route path="/edit-profile" element={<EditProfilePage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/product/:slug" element={<ProductDetailsPage />} />
        <Route path="/all-products" element={<AllProductsPage />} />
<Route path="/customer-reviews" element={<CustomerReviewsPage />} />

        {/* ================== ADMIN AREA (ALL PROTECTED + ADMIN LANG) ================== */}
<Route path="/admin/login" element={<AdminLogin />} />

<Route
  path="/admin"
  element={
    <ProtectedAdminRoute>
      <AdminLayout />
    </ProtectedAdminRoute>
  }
>
  <Route path="dashboard" element={<AdminDashboard />} />

  <Route path="products" element={<AdminProducts />} />
  <Route path="products/add" element={<AdminAddProduct />} />
  <Route path="products/edit/:id" element={<AdminEditProduct />} />

  <Route path="categories" element={<AdminCategories />} />

  <Route path="orders" element={<AdminOrders />} />
  <Route path="orders/:id" element={<AdminOrderDetails />} />
  <Route path="orders/add" element={<AdminAddOrders />} />

<Route path="reviews" element={<AdminReviews />} />

  <Route path="users" element={<AdminUsers />} />
  <Route path="customers" element={<AdminCustomers />} />
  <Route path="customers/:id" element={<AdminCustomerProfile />} />

  <Route path="analytics" element={<AdminAnalytics />} />
  <Route path="settings" element={<AdminSettings />} />

  <Route path="notifications" element={<AdminNotifications />} />
  <Route path="inventory" element={<AdminInventory />} />

  <Route path="messages" element={<AdminMessages />} />
  <Route path="messages/:id" element={<AdminMessageView />} />

  <Route path="email-templates" element={<AdminEmailTemplates />} />
  <Route path="email-templates/:key" element={<AdminEmailEditor />} />

  <Route path="seo" element={<AdminSeoManager />} />
  <Route path="top-banner" element={<AdminTopBanner />} />
  <Route path="sale-banner" element={<AdminSaleBanner />} />
  <Route path="shipping" element={<AdminShippingSettings />} />

  <Route path="products/new-in" element={<AdminNewInProducts />} />
  <Route path="products/bestsellers" element={<AdminBestsellerProducts />} />
  <Route path="products/on-sale" element={<AdminSaleProducts />} />
  <Route path="/admin/products/make-sale" element={<AdminMakeSale />} />
  <Route path="/admin/products/remove-sale" element={<AdminRemoveSale />} />


  <Route path="/admin/abandoned-carts" element={<AdminAbandonedCarts />} />
  <Route path="users-activity" element={<AdminUserActivity />} />

  <Route
  path="/admin/email-template-manager"
  element={
    <ProtectedAdminRoute requiredPermission="can_manage_marketing">
      <AdminEmailTemplateManager />
    </ProtectedAdminRoute>
  }
/>


</Route>

      </Routes>
    </Router>
  );
}

export default App;
